<template>
  <div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    ref="modal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content border-0 shadow">
        <div class="modal-header bg-danger">
          <h5 class="modal-title text-white">Confirm Delete</h5>
          <button type="button" class="btn-close text-white" @click="hide"></button>
        </div>
        <div class="modal-body">
          <p class="mb-0">
            Are you sure you want to delete
            <strong>{{ itemName }}</strong>?
            This action cannot be undone.
          </p>
          <div v-if="$slots.details" class="mt-3">
            <slot name="details" />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hide">Cancel</button>
          <button type="button" class="btn btn-danger" :disabled="confirmDisabled" @click="confirmDelete">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from "vue";

const props = defineProps({
  show: { type: Boolean, default: false },
  itemName: { type: String, default: "this record" },
  confirmDisabled: { type: Boolean, default: false },
  closeOnConfirm: { type: Boolean, default: true }
});
const emit = defineEmits(["confirm", "update:show"]);

const modal = ref(null);
let bsModal = null;

// Handle Bootstrap modal events to sync state
const handleHidden = () => {
  emit("update:show", false);
};

const setupModalListeners = () => {
  if (modal.value) {
    modal.value.addEventListener("hidden.bs.modal", handleHidden);
  }
};

const removeModalListeners = () => {
  if (modal.value) {
    modal.value.removeEventListener("hidden.bs.modal", handleHidden);
  }
};

watch(
  () => props.show,
  (val) => {
    if (!bsModal) {
      // lazy init
      import("bootstrap/dist/js/bootstrap.bundle.min.js").then(({ Modal }) => {
        bsModal = new Modal(modal.value, { backdrop: "static" });
        setupModalListeners();
        if (val) bsModal.show();
      });
    } else {
      if (val) {
        // Ensure modal is properly reset before showing
        // Remove any leftover classes that might prevent the modal from showing
        if (modal.value) {
          modal.value.classList.remove("show");
          modal.value.style.display = "";
          modal.value.setAttribute("aria-hidden", "true");
          modal.value.removeAttribute("aria-modal");
        }
        // Use setTimeout to ensure DOM is ready
        setTimeout(() => {
          bsModal.show();
        }, 10);
      } else {
        bsModal.hide();
      }
    }
  }
);

onMounted(() => {
  // Setup listeners when component is mounted
  if (modal.value) {
    setupModalListeners();
  }
});

onUnmounted(() => {
  // Clean up listeners
  removeModalListeners();
});

const hide = () => {
  if (bsModal) bsModal.hide();
  emit("update:show", false);
};

const confirmDelete = () => {
  emit("confirm");
  if (props.closeOnConfirm) hide();
};
</script>